import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import {
  ArrowLeft,
  Heart,
  SlidersHorizontal,
  MessageCircle,
  Ellipsis,
  Bone,
  Check,
  Plus,
  ChevronDown,
  MapPin,
} from "lucide-react";
import "./ProfileDetailsPage.css";
// import profileMain from "../../assets/profileMain2.png";
import dogSettingsIcon from "../../assets/progressIcon6.png";
import sliderDogHead from "../../assets/dogHead.png";
import dogPlaceholder from "../../assets/dogPlaceholder.png";
import userPlaceholder from "../../assets/userPlaceholder.png";

const BookAWalkTeamPawsPage = ({ filterData, setFilterData }) => {
  const navigate = useNavigate();

  const [isFilterOpen, setIsFilterOpen] = useState(false);

  // Filter Panel Toggles
  const { teamSelection, proximityValue, availability, breed } = filterData;

  const TRACK_START = 5;
  const TRACK_END = 95;
  const TRACK_RANGE = TRACK_END - TRACK_START;
  const PROXIMITY_STEPS = 4; // 0–4 (5 values)

  const toggleFilter = () => setIsFilterOpen(!isFilterOpen);

  const toggleAvailability = (option) => {
    let newAvailability;
    if (availability.includes(option)) {
      newAvailability = availability.filter((item) => item !== option);
    } else {
      newAvailability = [...availability, option];
    }
    setFilterData((prev) => ({ ...prev, availability: newAvailability }));
  };

  const handleProximityChange = (val) => {
    setFilterData((prev) => ({ ...prev, proximityValue: val }));
  };

  const handleTeamChange = (val) => {
    setFilterData((prev) => ({ ...prev, teamSelection: val }));
  };

  const handleBreedChange = (val) => {
    setFilterData((prev) => ({ ...prev, breed: val }));
  };

  const handleGoToMessagesPage = () => {
    navigate("/messages");
  };

  const handleImgError = (e) => {
    e.target.src = dogPlaceholder;
  };

  return (
    <div
      className="profile-detail-container-rt"
      style={{
        minHeight: "100dvh",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        maxWidth: "100%",
      }}
    >
      {/* HEADER */}
      <div
        style={{
          position: "relative",
          height: 64,
          padding: "0 16px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <button
          className="back-btn"
          onClick={() => navigate(-1)}
          style={{
            position: "absolute",
            left: 16,
            top: "50%",
            transform: "translateY(-50%)",
            display: "flex",
            alignItems: "center",
            gap: 6,
            background: "none",
            border: "none",
            cursor: "pointer",
          }}
        >
          <ArrowLeft size={24} color="#fff" strokeWidth={3} />
          <span>Back</span>
        </button>

        <div
          style={{
            position: "absolute",
            right: 1,
            top: "55%",
            transform: "translateY(-50%)",
            display: "flex",
            alignItems: "center",
            gap: 19,
          }}
        >
          <button className="icon-btn-list" onClick={toggleFilter}>
            <SlidersHorizontal size={24} color="#fff" />
          </button>
          <button className="icon-btn-list" onClick={handleGoToMessagesPage}>
            <MessageCircle size={24} color="#fff" />
          </button>
          <div className="list-avatar">
            <img src={dogSettingsIcon} alt="Profile" />
            <Ellipsis size={24} color="#fff" />
          </div>
        </div>
      </div>

      {/* CENTER */}
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          maxWidth: "100%",
        }}
      >
        <div
          className="detail-left-panel"
          style={{
            width: 730,
            height: 725,
            maxWidth: "none",
            display: "flex",
            flexDirection: "column",
            flexShrink: 0,
          }}
        >
          <div
            className="profile-summary-card-rt"
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: 20,
              gap: 16,
            }}
          >
            {/* TOP TEXT */}
            <div
              style={{
                textAlign: "center",
                fontSize: "1.5rem",
                fontWeight: 700,
                lineHeight: 1.4,
              }}
            >
              Angela would like to Offer a Walk with You & Dimsum!
            </div>

            {/* IMAGE BLOCK */}
            <div
              className="main-image-container-rt"
              style={{
                position: "relative",
                height: 375,
                width: 460,
                borderRadius: 16,
                overflow: "hidden",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  padding: "24px 12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background:
                    "linear-gradient(0deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.7) 100%)",
                }}
              ></div>
              {/* <img
                src={profileMain || dogPlaceholder}
                alt="Dimsum"
                onError={handleImgError}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              /> */}

              {/* Bottom overlay info INSIDE image */}
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  padding: "12px 14px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 10,
                  background:
                    "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.7) 100%)",
                }}
              >
                <Heart size={40} color="#fff" strokeWidth={2} />
                <span
                  style={{
                    color: "#fff",
                    fontSize: "1.875rem",
                    fontWeight: 600,
                  }}
                >
                  Angela
                </span>
                <span
                  style={{
                    color: "rgba(255,255,255,1)",
                    fontSize: "1.125rem",
                    fontWeight: 500,
                  }}
                >
                  2.5mi away
                </span>
              </div>
            </div>

            {/* BOTTOM TEXT */}
            <div
              style={{
                fontSize: "1.375rem",
                lineHeight: 1.4,
                textAlign: "start",
                padding: "0 70px",
                fontWeight: "600",
              }}
            >
              Angela has suggested to meet on Wed, Sept 3rd at 8:30am at Dewitt
              Clinton Park Dog Run
            </div>

            {/* BUTTONS */}
            <div className="profile-action-btns" style={{ marginTop: "10px" }}>
              <button
                className="profile-btn secondary"
                style={{
                  width: "220px",
                  fontSize: "0.85rem",
                  backgroundColor: "transparent",
                  border: "0.67px solid rgba(0, 0, 0, 0.5)",
                  boxShadow: "0px 2.68px 2.68px 0px rgba(0, 0, 0, 0.1)",
                }}
              >
                SUGGEST ANOTHET TIME
              </button>
              <button
                className="profile-btn primary"
                style={{ width: "220px", fontSize: "0.85rem" }}
              >
                ACCEPT TIME
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* FILTER SIDE PANEL (DRAWER) */}
      <div className={`filter-panel ${isFilterOpen ? "open" : ""}`}>
        <div className="filter-content">
          <div className="filter-header">
            <h2>Filters</h2>
            {/* Optional close button for mobile/convenience */}
            {/* <button className="close-filter-btn" onClick={toggleFilter}><X size={24}/></button> */}
          </div>

          {/* SEARCH */}
          <div className="filter-section">
            <label className="filter-label">SEARCH</label>
            <div className="search-input-wrapper">
              <input
                type="text"
                placeholder="Names, Location, Dates.."
                className="filter-text-input"
              />
            </div>
          </div>

          {/* TEAM */}
          <div className="filter-section">
            <label className="filter-label">TEAM</label>
            <div className="team-toggle-group">
              <button
                className={`team-toggle-btn ${
                  teamSelection === "paws" ? "active-paws" : ""
                }`}
                onClick={() => handleTeamChange("paws")}
              >
                {teamSelection === "paws" && (
                  <Check size={20} strokeWidth={3} />
                )}
                Pups
                <Bone
                  size={32}
                  stroke="rgba(164, 217, 235, 1)"
                  strokeWidth={3}
                  fill="rgba(164, 217, 235, 1)"
                  style={{ transform: "rotate(45deg)" }}
                />
              </button>
              <button
                className={`team-toggle-btn ${
                  teamSelection === "social" ? "active-social" : ""
                }`}
                onClick={() => handleTeamChange("social")}
              >
                {teamSelection === "social" && (
                  <Check size={20} strokeWidth={3} />
                )}
                Pup Pals
                <Heart size={27} stroke="none" fill="rgba(71, 215, 172, 1)" />
              </button>
            </div>
          </div>

          {/* PROXIMITY (CUSTOM SLIDER) */}
          <div className="filter-section">
            <label className="filter-label">PROXIMITY</label>
            <div className="proximity-options">
              <div className="proximity-radio">
                <MapPin size={18} />
                <span>Search point-pulled from your profile pin</span>
              </div>
              <div className="proximity-radio">
                <Plus size={18} />
                <span>Specify new location</span>
              </div>
            </div>
            <p className="slider-value-text">{proximityValue + 1} Blocks</p>

            {/* Reusing the slider logic from previous task */}
            <div className="filter-slider-container">
              <div className="filter-slider-track-bg"></div>

              {/* Track fill */}
              <div
                className="filter-slider-track-fill"
                style={{
                  width: `${
                    TRACK_START +
                    (proximityValue / PROXIMITY_STEPS) * TRACK_RANGE
                  }%`,
                }}
              />

              {/* Slider dots */}
              {[0, 1, 2, 3, 4].map((step) => (
                <div
                  key={step}
                  className="filter-slider-dot"
                  style={{
                    left: `${
                      TRACK_START + (step / PROXIMITY_STEPS) * TRACK_RANGE
                    }%`,
                  }}
                  onClick={() => handleProximityChange(step)}
                />
              ))}

              {/* Dog head thumb */}
              <div
                className="filter-slider-thumb"
                style={{
                  left: `${
                    TRACK_START +
                    (proximityValue / PROXIMITY_STEPS) * TRACK_RANGE
                  }%`,
                }}
              >
                <img src={sliderDogHead} alt="Slider Dog" />
              </div>

              {/* Click area (full width for UX) */}
              <div
                className="filter-slider-click-layer"
                onClick={(e) => {
                  const rect = e.currentTarget.getBoundingClientRect();
                  const rawPercent =
                    ((e.clientX - rect.left) / rect.width) * 100;

                  const clamped = Math.min(
                    TRACK_END,
                    Math.max(TRACK_START, rawPercent),
                  );

                  const normalized = (clamped - TRACK_START) / TRACK_RANGE;

                  const step = Math.round(normalized * PROXIMITY_STEPS);
                  handleProximityChange(step);
                }}
              />
            </div>
          </div>

          {/* AVAILABILITY */}
          <div className="filter-section">
            <label className="filter-label">AVAILABILITY</label>
            <div className="availability-grid">
              {[
                "Weekdays",
                "Weekends",
                "Vacations",
                "Mornings",
                "Afternoons",
                "Evenings",
              ].map((option) => {
                const isActive = availability.includes(option.toLowerCase());
                return (
                  <button
                    key={option}
                    className={`availability-btn ${isActive ? "active" : ""}`}
                    onClick={() => toggleAvailability(option.toLowerCase())}
                  >
                    {isActive && <Check size={16} strokeWidth={3} />}
                    {option}
                  </button>
                );
              })}
            </div>
          </div>

          {/* BREED */}
          <div className="filter-section">
            <label className="filter-label">BREED</label>
            <div className="breed-dropdown-wrapper">
              <select
                className={`breed-dropdown ${
                  breed === "" ? "placeholder" : ""
                }`}
                value={breed}
                onChange={(e) => handleBreedChange(e.target.value)}
              >
                <option value="" disabled hidden>
                  Type or choose breed
                </option>
                <option value="labrador">Labrador</option>
                <option value="poodle">Poodle</option>
              </select>

              <ChevronDown size={20} className="dropdown-icon" />
            </div>
          </div>

          {/* FOOTER BUTTONS */}
          <div className="filter-footer-btns">
            <button className="filter-cancel-btn" onClick={toggleFilter}>
              CANCEL
            </button>
            <button className="filter-sniff-btn">SNIFF 27 RESULTS</button>
          </div>
        </div>
      </div>

      {/* Overlay to close filter on click outside */}
      {isFilterOpen && (
        <div className="filter-overlay-bg" onClick={toggleFilter}></div>
      )}
    </div>
  );
};

export default BookAWalkTeamPawsPage;
